import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';
import {pickBy, omitBy, isNil } from 'lodash';
import { Store, select } from '@ngrx/store';
import { MenuItem } from "primeng/api";

import * as fromStore from '@app/core/store';
import { ScreenComponent } from '@core/features/screen.component';
import * as fromMaster from '@features/master/create-user-wizard/store';

import { UserService } from '@services-api/user.service';
import { HttpClient } from '@angular/common/http';
import { FeatureService } from '@services/feature/feature.service';
import { User as UserModel } from '@models/user.model';






/**
* This Component manages the presentation logic of Edit screen
*
*/
@Component({
selector: 'app-master-create-user-wizard',
templateUrl: './master-create-user-wizard.component.html',
styles: [
  `
    .ui-steps .ui-steps-item {
      width: 25%;
    }

    .ui-steps.steps-custom {
      margin-bottom: 30px;
    }

    .ui-steps.steps-custom .ui-steps-item .ui-menuitem-link {
      padding: 0 1em;
      overflow: visible;
    }

    .ui-steps.steps-custom .ui-steps-item .ui-steps-number {
      background-color: #0081c2;
      color: #ffffff;
      display: inline-block;
      width: 36px;
      border-radius: 50%;
      margin-top: -14px;
      margin-bottom: 10px;
    }

    .ui-steps.steps-custom .ui-steps-item .ui-steps-title {
      color: #555555;
    }
  `
],
encapsulation: ViewEncapsulation.None
})
export class MasterCreateUserWizardComponent extends ScreenComponent implements OnInit {

  vars : any = {} ;
  loading$: Observable<boolean>;
  data$: Observable<any>;
  currentIndex$: Observable<number>;
  activeIndex: number = 0;
  items: MenuItem[] = [
      {
        label: "",
        disabled: false,
        command: (event: any) => {
          this.activeIndex = 0;
        }
      },
      {
        label: "",
        disabled: true,
        command: (event: any) => {
          this.activeIndex = 1;
        }
      },
  ];
  stepsConfig: any[] = [
        {
          feature: "master",
          screenType: "create-user",
          screenId: "-create-user-screen"
        },
        {
          feature: "master",
          screenType: "access-profile",
          screenId: "-access-profile-screen"
        },
    ];
  /**
  * Default Constructor of the component
  */
  constructor(
    private featureService: FeatureService,
private httpClient: HttpClient,
private service: UserService,

    
    
    router: Router,
    store: Store<fromMaster.State>,
    activeRoute: ActivatedRoute){
      super(activeRoute, store, router);
  }

  ngOnInit() {
    super.ngOnInit();
    this.ctx = this.getScreenCtx();
    this.store.dispatch(
      fromMaster.initStateAction({ ...this.params, currentIndex: 0  })
    );
    this.data$ = this.store.pipe(
    fromStore.selectData(this.ctx),
      tap(item => this.init(item))
    );
    this.currentIndex$ = this.store.pipe(
      select(fromStore.selectProperty, {
        ...this.ctx,
        id: this.screenId,
        property: "currentIndex"
      })
    );
    this.currentIndex$.pipe(takeUntil(this.destroy$)).subscribe(index => {
      this.activeIndex = index;
      this.items[this.activeIndex].disabled = false;
    });
    this.loading$ = this.store.select(fromStore.selectLoading, this.ctx);
    this.openStepsScreens();
  }

  /**
  * Initialize the component by the provided data object
  * @param item
  */
  init(item) {
    this.data = { ...pickBy(this.data), ...omitBy(item, isNil)};
  }

  getPayload() {
    return {
      ...this.params,
      ...this.ctx,
      code: this.getCode(),
      keys: this.keys,
      parentCtx: { ...this.parentCtx }
    };
  }

  private getCode() {
    return this.parentCtx && this.parentCtx.code
      ? this.parentCtx.code
      : this.getParamCode();
  }
  private getParamCode() {
    const id = this.activeRoute.snapshot.params.id;
    return id && !id.startsWith('{') ? id : undefined;
  }

  getScreenCtx() {
    return fromStore.buildScreenCtx(
      'Master',
      'CreateUserWizard',
      this.screenId,
      this.parentCtx ? this.parentCtx.roleName : null,
      this.parentCtx ? this.parentCtx.rootId : null,
      this.parentCtx && this.parentCtx.roleName
      ? this.screenId + ',' + this.parentCtx.screenId
      : null);
  }

  openStepsScreens() {
    this.router.navigate(
      [
        "./",
        {
          outlets: {
              "CreateUserScreen": [
              "CreateUserScreen",
              "create-user",
              {
                id: JSON.stringify({
                  ...this.ctx,
                  rootId: this.screenId
                }),
                screenId: this.screenId + "-create-user-screen"
              }
            ],
              "AccessProfileScreen": [
              "AccessProfileScreen",
              "access-profile",
              {
                id: JSON.stringify({
                  ...this.ctx,
                  rootId: this.screenId
                }),
                screenId: this.screenId + "-access-profile-screen"
              }
            ],
            }
        }
      ],
      {
        relativeTo: this.activeRoute,
        queryParamsHandling: "merge",
        skipLocationChange: true
      }
    );
  }

  doNext() {
    this.store.dispatch(
      fromMaster.nextAction({
        id: this.screenId,
        ...this.ctx,
        target: {...this.stepsConfig[this.activeIndex]}
      })
    );
  }

  doPrevious() {
    this.store.dispatch(
      fromMaster.previousAction({
        id: this.screenId,
        ...this.ctx
      })
    );
  }

  doConfirm() {
    this.store.dispatch(
      fromMaster.confirmAction({
        id: this.screenId,
        ...this.ctx,
        target: {...this.stepsConfig[this.activeIndex]}
      })
    );
  }

}
